import {
  initialState,
  Actions,
  State,
  DELETE_POST_FILE,
  DELETE_POST_FILE_SUCCESS,
  DELETE_POST_FILE_ERROR,
  RESET_DELETE_POST_FILE,
} from "../../types/post/delete-file";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_POST_FILE:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_POST_FILE_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_POST_FILE_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_POST_FILE:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
